import { Schema } from "@comparaonline/products-schema";
import React from "react";
import { Query, QueryProps, QueryResult } from "react-apollo";
import { useAppContext } from "../../../lib/appContext";
import { getProducts } from "../getProducts";

export interface ProductListQueryData {
  productList?: {
    products: Schema.ProductListProduct[];
    filters: Schema.ProductListFilter[];
    totalResults: number;
  };
}

type QueryArguments = Schema.ProductListQueryArgs;

class BaseQuery extends Query<ProductListQueryData, QueryArguments> {}

export type IProductListQueryResult = QueryResult<ProductListQueryData, QueryArguments>;

interface IProductListQueryProps
  extends Pick<QueryProps<ProductListQueryData, QueryArguments>, "children"> {
  filters: string[];
  count: number;
  page: number;
}

export const ProductsQuery: React.FC<IProductListQueryProps> = ({ children, ...props }) => {
  const {
    businessUnitConfig: { businessCode }
  } = useAppContext();
  return (
    <BaseQuery
      query={getProducts}
      variables={{
        businessUnit: businessCode,
        ...props
      }}
    >
      {data => children(data)}
    </BaseQuery>
  );
};
